/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

import laughingLady from "../assets/laughingLady.png";
import IndomieSample from "../assets/indomie.png";

const DashboardPhaseTwo: React.FC = () => {
  return (
    <div className="mt-6 md:mt-0 w-full bg-[#F7F6F6] rounded-xl">
      <div className="flex">
        <div className="flex flex-col md:flex-row">
          <div
            className="hidden md:inline md:w-[200px] md:h-[200px]"
            style={{
              backgroundImage: `url(${IndomieSample})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          ></div>
          <div className="flex flex-col pt-4">
            <h2 className="text-[#DC0315] text-[25px] md:text-[37px] font-bold text-center">
              Delve into your Promo insights using Analytics
            </h2>

            <iframe src="https://public.tableau.com/views/public_exercise/Dashboard1?:showVizHome=no&:embed=true"></iframe>
          </div>
        </div>

        <div className="hidden md:inline-flex md:ml-auto">
          <img src={laughingLady} alt="" width={400} height={400} />
        </div>
      </div>
    </div>
  );
};

export default DashboardPhaseTwo;
